import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import { AddButton } from "../../../utils/Custom/Button";
import { useLocation, useNavigate } from "react-router-dom";
import { submitSiteDelete } from "../../../utils/commonComponent/delete";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import ListSearchSection from "../../../utils/Custom/ListSearchSection";
import { clienTypes } from "../../../utils/commonComponent/common";
import { getPermissions } from "../rbac/hasAccess";
import { formateDate, paginationrowsPerPageOptions } from "../../../utils/commonComponent/commonConstant";
import { textTruncate } from "../../../utils/commonComponent/truncate";
import moment from "moment";

const headers = ["id", "PayingParty", "address", "jobNumber", "poNumber", "inspectionStartDate", "inspectionEndDate"];

const fields = [
  { value: "client", label: "PayingParty" },
  { value: "jobNumber", label: "Job Number" },
  { value: "poNumber", label: "Po Number" }
];

const JobRegisterList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/editJobRegister/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("jobRegister", row.id);

  const [jobRegisterList, setJobRegisterList] = React.useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [allJobsData, setAllJobsData] = useState([]);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "client");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
  // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));


  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
    sessionStorage.setItem("ListPageCount", page);
    sessionStorage.setItem("ListRowsPerPage", rows);
  };

  const getWhereClause = () => {
    let whereConditions = "";
    const colMap = {
      client: "cl.companyName",
      jobNumber: "jR.jobNumber",
      poNumber: "jR.poNumber",
    };
    const colName = colMap[searchBy];
    if (colName && searchKey.trim()) {
      whereConditions = `WHERE LOWER(${colName}) LIKE LOWER('%${searchKey.trim()}%')`;
    }

    return whereConditions;
  };
  const getDataQuery = () => {
    const whereClause = getWhereClause();
    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage)}`;
    }
    let query = `SELECT jR.*, cl.companyName as Client, cl.type as clientType, a.address AS address, a.coordinates FROM jobRegister jR LEFT JOIN clients cl ON jR.clientId = cl.id LEFT JOIN addresses a ON jR.address = a.id ${whereClause} ORDER BY jR.id DESC ${paginationSettings};`;

    return query;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();
    return `SELECT COUNT(*) AS totalRows FROM jobRegister jR LEFT JOIN clients cl ON jR.clientId = cl.id LEFT JOIN addresses a ON jR.address = a.id ${whereClause};`;
  };

  const fetchData = async () => {
    try {
      const allDataQuery = fetchAllJobsData();
      const [jobData, countResult, allJobsData] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
        fetchQuery(allDataQuery)
      ]);
      const modified = jobData.map((item) => ({
        ...item,
        PayingParty: item.Client + (item.clientType ? ` (${clienTypes.find((ct) => ct.value == item.clientType)?.short || ""})` : ""),
      }));

      const modifiedAllJobsData = allJobsData.map((item) => ({
        ...item,
        address: item.fullAddress || "",
        PayingParty: item.Client + (item.clientType ? ` (${clienTypes.find((ct) => ct.value == item.clientType)?.short || ""})` : ""),
        inspectionStartDate : item.inspectionStartDate ? moment(item.inspectionStartDate).format("DD-MM-YYYY") : "",
        inspectionEndDate : item.inspectionEndDate ? moment(item.inspectionEndDate).format("DD-MM-YYYY") : "",

      }));
      setJobRegisterList(modified);
      setTotalRows(countResult?.[0]?.totalRows || 0);
      setAllJobsData(modifiedAllJobsData);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("client");
    setSearchKey("");
    // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  const fetchAllJobsData = () => {
    const whereClause = getWhereClause();
      return `SELECT jR.*, cl.companyName as Client, cl.type as clientType, a.address AS fullAddress, a.coordinates FROM jobRegister jR LEFT JOIN clients cl ON jR.clientId = cl.id LEFT JOIN addresses a ON jR.address = a.id ${whereClause} ORDER BY jR.id DESC`;
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/editJobRegister/0"
          label="Add Job"
          icon={<AddIcon fontSize="small" />}
        />
      )}

      <ListSearchSection
        title="Search Job"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
        showExcelDownload={permissions.excelDownload || permissions.allAccess}
        finalData={allJobsData}
        notNeededColumn={["id", "clientId", "clientType", "fullAddress", "coordinates", "state", "location","inspectionLocation", "Client"]}
      />

      <div className="w-full border rounded-md shadow">
        {/* Table Container with Fixed Height */}
        <div className="overflow-y-auto h-auto max-h-[450px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs font-medium text-gray-600 z-10">
              <tr>
                <th className="px-4 py-3 whitespace-nowrap">Sr. No.</th>
                <th className="px-4 py-3 whitespace-nowrap">Paying Party</th>
                <th className="px-4 py-3 whitespace-nowrap">Address</th>
                <th className="px-4 py-3 whitespace-nowrap">Job Number</th>
                <th className="px-4 py-3 whitespace-nowrap">PO Number</th>
                <th className="px-4 py-3 whitespace-nowrap">Inspection Start Date</th>
                <th className="px-4 py-3 whitespace-nowrap">Inspection End Date</th>
                {(permissions.edit || permissions.delete || permissions.allAccess) && (
                  <th className="px-4 py-3 text-center">ACTIONS</th>
                )}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {jobRegisterList.length > 0 ? (
                jobRegisterList.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td className="px-4 py-3">{currentPage * rowsPerPage + rowIndex + 1}</td>
                    <td className="px-4 py-3">{textTruncate(row.PayingParty)}</td>
                    <td className="px-4 py-3">{textTruncate(row.address)}</td>
                    <td onClick={() => handleEdit(row)} className="cursor-pointer hover:text-blue-600 px-4 py-3">{row.jobNumber || ""}</td>
                    <td className="px-4 py-3">{row.poNumber || ""}</td>
                    <td className="px-4 py-3 whitespace-nowrap">{formateDate(row.inspectionStartDate)}</td>
                    <td className="px-4 py-3 whitespace-nowrap">{formateDate(row.inspectionEndDate)}</td>
                    <td className="px-4 py-2 text-center whitespace-nowrap">
                      <div className="flex items-center justify-center gap-2">
                        {(permissions.edit || permissions.allAccess) && (
                          <button
                            onClick={() => handleEdit(row)}
                            className="text-blue-600"
                          >
                            <EditIcon fontSize="small" />
                          </button>
                        )}
                        {(permissions.delete || permissions.allAccess) && (
                          <button
                            onClick={() => handleDelete(row)}
                            className="text-blue-600"
                          >
                            <DeleteIcon fontSize="small" />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center py-4 text-gray-500">
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between px-4 py-2 bg-blue-50 text-sm border-t">
          <div className="flex items-center gap-2">
            <span>Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) => handlePaginationChange(0, Number(e.target.value))}
              className="border rounded px-2 py-1 text-sm"
            >
              {paginationrowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-gray-600">
              {totalRows === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                  (currentPage + 1) * rowsPerPage,
                  totalRows
                )} of ${totalRows}`}
            </span>
            <button
              onClick={() => handlePaginationChange(0, rowsPerPage)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(currentPage - 1, rowsPerPage)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(currentPage + 1, rowsPerPage)}
              disabled={currentPage >= Math.ceil(totalRows / rowsPerPage) - 1}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(Math.ceil(totalRows / rowsPerPage) - 1, rowsPerPage)}
              disabled={currentPage >= Math.ceil(totalRows / rowsPerPage) - 1}
              className="p-1 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobRegisterList;